/*
 * @Author: jianwen.Wang
 * @Date: 2022-01-25 17:28:22
 * @LastEditTime: 2023-06-16 14:33:52
 * @LastEditors: yunpeng.li yunpeng.li@sdbean.com
 */
import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { addresses } from '../constants'
// import { BigNumberish, ethers } from 'ethers'
import { RootState } from '../store'
import { setAll } from '../helpers'
import { checkAuthTokenValid, noticeList } from '@/api/apiAccount'
// import { countryarea, promptHelperJson } from '@/api/apiCommon'
import { message } from 'antd'
// import { NoticeListResponse } from '@/pages/sdModelList'
// import GlobalStorage from '@/lib/globalStorage'

export interface Message {
    content: string
    role: string
    date?: Date
}
export interface Session {
    chatHistoryRecord: Array<Message>
    session: string | undefined
    model?: string
    modelId?: number
}

export interface IAppData {
    readonly loading: boolean
    userName: string
    password: string
    authToken: string | undefined
    vistorAuthToken: string | undefined
    uniqueCode: string | undefined
    isValid: boolean
    sessionList: Array<Session>
    currentSession: Session | null
    selectExample: string
    menuOpen: boolean
    showLogin: boolean
    isShowWelcomePage: boolean
    countryArea: { country: string; area: string }[]
    promptHelpers: Array<any>
    promptHelpersLanguage: string
    host: string
}
const initialState: IAppData = {
    loading: false,
    userName: '',
    password: '',
    authToken: '',
    vistorAuthToken: '',
    uniqueCode: '',
    isValid: false,
    sessionList: [],
    currentSession: null,
    selectExample: '',
    menuOpen: false,
    showLogin: false,
    isShowWelcomePage: false,
    countryArea: [],
    promptHelpers:[],
    promptHelpersLanguage: '',
    host: ''
}
export const loadAppDetails = createAsyncThunk('app/loadAppDetails', async ({}:any, { dispatch }) => {

    // let promptHelpersLanguage = window.location.host.includes('mst.ai') ? "EN": "CN"
    // const res: any = await promptHelperJson({})
    // let promptHelpers = res.promptHelpers
    // let host = window.location.host.includes('mst.ai') ? "ai": "xyz"

    return {} as IAppData
    
})

export const fetchCheckAuthTokenValid = createAsyncThunk('app/fetchCheckAuthTokenValid', async ({ authToken }: any, { dispatch }) => {
    const result = await checkAuthTokenValid({ authToken })
    if (result.code == 1) {
        // if (result.data.isValid) {
        //     setAuthToken(GlobalStorage.get('auth_token'))
        // } else {
        //     GlobalStorage.remove('auth_token')
        //     // window.location.reload()
        // }
    }
})


const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload
        },
    }
   
})
const baseInfo = (state: RootState) => state.app
export default appSlice.reducer
export const {
    setLoading,
  
} = appSlice.actions

export const getAppState = createSelector(baseInfo, app => app)
